<template>
  <div class="row d-flex flex-wrap appTitle">
    <div id="goBackButton" class="arrow" :class="{ hoveredArrow : isHoverHeader }"
         @click="goBack()"
         @mouseover="changeToBlueArrow()"
         @mouseleave="changeToBlackArrow()"
    ></div>
    <img :src="appInfoData.imageUrl.url"/>
    <div class="nameArea">
      <div id="name" class="titleName">{{appInfoData.name}}</div>
    </div>
  </div>
</template>

<script>


  
  export default {
    name: 'app-title',
    props: {
      appInfoData: {type: Object, required: true},
      uuid: String,
      backUrl: String,
    },
    data() {
      return {
        isHoverHeader: false,
         
      }
    },

    methods: { 
      goBack() {
      // this.$session.set("flag-value",true);
        this.$session.set("selectedFilterData-flag", true);
         this.$router.push(window.history.length > 1 ? this.$router.push('/allSolution')  : this.$router.go(-1) );
       // this.$router.push(window.history.length > 1 ? this.$router.go(-1)  : this.$router.push('/solutionOfMonth') );
      //this.$router.push("/solutionOfMonth");
      },
      lastRouteName(){
 let returnVal = '';

  const routerStack = this.$router.history.stack;
  const idx = this.$router.history.index;

  if (idx > 0) {
    returnVal = routerStack[idx - 1].name;
  }

  return returnVal;
      },
      
      changeToBlueArrow() {
        this.isHoverHeader = true;
      },
      changeToBlackArrow() {
        this.isHoverHeader = false;
      }
    }
  }
</script><style lang="scss" scoped>
 @import "../../styles/hpConstant.scss";
  @import "../../styles/hpMixin.scss";
  @import "../../styles/hpCommon.scss";

  @mixin contentArea($minWidth, $maxWidth) {
    min-width: $minWidth;
    max-width: $maxWidth;
  }

  .appTitle {
    @include userSelectNone;
    // display: inline-flex;

    .arrow {
      height: 0.75rem;
      width: 0.75rem;
      // margin: 11px 18px 0 0;
      margin-top: 1%;
      border-right: 2px solid black;
      border-bottom: 2px solid black;
      cursor: pointer;
      -webkit-transform: rotate(135deg);
      -ms-transform: rotate(135deg);
      transform: rotate(135deg);
    }

    img {
      width: 4rem;
      height: 4rem;
      // margin: 4px 5px 0 0;
      margin-left: 2%;
    }

    .hoveredArrow {
      border: solid $hpLightBlue;
      border-width: 0 2px 2px 0;
    }

    .nameArea {
      margin-left: 2%;
      font-family: "FormaDJR";
      // padding-left: 10px;
      // display: flex;

      .titleName {
        @include ellipsis;
        white-space: normal;
        word-wrap: break-word;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        // max-height: 170px;
        // max-width: 340px;
        line-height: 2rem;
        // padding-top: 5px;
        color: $hpLightBlack;
        font-weight: bold;
        font-size: 2rem;
      }
    }
  }
</style>
